import { BKJSideModal } from 'components/BKJSideModal';
import { useTieringDetailsModalUIContext } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.ui.context';
import { useTranslation } from 'hooks/useTranslation';
import { FC, useMemo } from 'react';
import {
  ShiftDistributionComponentMap,
  tieringDetailsModalRoutingService,
} from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModalRouting.constants';

export const TieringDetailsModalModalComponent: FC = () => {
  const { isOpen, tieringDetailsActiveModalView } = useTieringDetailsModalUIContext();

  const { t } = useTranslation();

  const Component = useMemo(
    () => ShiftDistributionComponentMap[tieringDetailsActiveModalView],
    [tieringDetailsActiveModalView],
  );

  const modalHeader = {
    TieringDetails: t('location_settings:TIERING_DETAILS'),
    SharingDetails: t('location_settings:SHARING_DETAILS'),
    ShiftBiddingDetails: t('location_settings:SHIFT_BIDDING_RULES'),
  };
  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={tieringDetailsModalRoutingService.close}
      headerComponent={modalHeader[tieringDetailsActiveModalView]}
    >
      {isOpen && <Component />}
    </BKJSideModal>
  );
};
